import React from 'react';
import Logo from '../../atoms/logo';
import Card from '../../organisms/card';
import { Container, Row, Col } from '../../../grid';

const PatientNotFoundPage: React.FC = (): JSX.Element => {
  return (
    <div
      style={{
        width: '100%', //isSubComponent ? '100%' : '100vw',
        height: '80vh'
      }}
    >
      <Container>
        <Row>
          <Col md={10} offset={{ md: 7 }}>
            <header className="text-center mt-100 mb-8">
              <Logo maxWidth={250} darkVersion />
              <Card className="mb-8">
                <h1 className="text-sans-lg mb-7 text-center">
                  No Record Found
                </h1>
                <p className="text-center">
                  Patient record cannot be located or is not active in
                  CareSignal.
                </p>
              </Card>
            </header>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PatientNotFoundPage;
